module.exports = __webpack_public_path__ + "static/floatys-41bede94b6adc413beb7c34b266f5280.jpg";